import { render, staticRenderFns } from "./LenderInfo.vue?vue&type=template&id=2b80231f&scoped=true"
import script from "./LenderInfo.vue?vue&type=script&lang=js"
export * from "./LenderInfo.vue?vue&type=script&lang=js"
import style0 from "./LenderInfo.vue?vue&type=style&index=0&id=2b80231f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b80231f",
  null
  
)

export default component.exports